import React from 'react';
import { UploadingVideo } from '@/utils/optimistic/optimisticUpload';
import UploadingTile from '@/utils/dashboard/UploadingTile';

interface UploadingImageTileProps {
  readonly uploadingImage: UploadingVideo;
}

/**
 * Individual uploading image tile component
 * Used in virtualized grid to render uploading image tiles
 */
const UploadingImageTile: React.FC<UploadingImageTileProps> = ({
  uploadingImage,
}) => {
  return (
    <UploadingTile
      status={uploadingImage.status}
      progress={uploadingImage.progress}
      aspectRatio="1/1"
    />
  );
};

export default UploadingImageTile;
